module.exports = __webpack_public_path__ + "static/media/zen-color.64d3ecb7.png";